// Mock data for Brooksgordon artist website

export const artistInfo = {
  name: "Brooksgordon",
  realName: "Ishma'el 'Brooks' Braggs",
  tagline: "Vocalist, Pianist & Songwriter",
  bio: `With a soulful sound often compared to legends like Luther Vandross, Brian McKnight, and Will Downing, Ishma'el "Brooks" Braggs is a classically trained pianist and soulful vocalist whose life has been dedicated to the art of music. With over 30 years of rigorous classical training, his journey began in Connecticut and Cuba before taking root in southeast Virginia, where he studied under the guidance of renowned vocal coach Gloria Amos and virtuoso pianist Diane Crane.

A Vocal Performance major at Norfolk State University, Ishma'el distinguished himself early — most notably during a piano practicum in which he sightread a piece of the professor's choosing, demonstrating what was described as "superior sightreading skills." He continued his studies at Old Dominion University, laying the foundation for a lifelong career in creation and performance.

From directing choirs in his teenage years to garnering the attention of major labels, Ishma'el has always evolved with the times. An entrepreneurial spirit led him to establish the BrooksGordon Music Company in 1998, taking control of his artistic destiny. This move paved the way for his recent work as an independent recording artist, including the release of his smooth, heartfelt single "When I'm With You," which he wrote and produced under his pseudonym, "Brooks."

This release is an exciting preview of a broader vision. Under the banner of his label and his artistic alias, "Brooksgordon," he has channeled a lifetime of musical experience into his debut full-length album, "The Gordon Principle" — out now and slated to be one of the most versatile albums ever created.

Today, that same passionate artist thrives on the stage, bringing his immense talent to vibrant, interactive live shows. He is a standout performer in the energetic "Dueling Pianos" scene, captivating crowds at venues like The Pourhouse in Statesboro, GA. His versatility was further showcased when he was invited to host and perform for the "Love & Poetry Experience" at Atlanta's esteemed Chicago Avenue Cafe, an event that highlighted his skill in curating an intimate atmosphere where soulful melodies meet powerful words.

Brooksgordon is available for bookings in the Atlanta metropolitan area, the Low Country region, and internationally. For sync licensing inquiries regarding The Gordon Principle, contact Ishmael.braggs@brooksgordon.com.

From the disciplined world of classical piano to the spontaneous thrill of dueling pianos and the curated intimacy of a featured hosting spot, Ishma'el "Brooks" Braggs—and his visionary project, Brooksgordon—remains a compelling and dynamic force in music, poised for an exciting new chapter.`,
  socialMedia: {
    instagram: "https://www.instagram.com/brooksgordon78?igsh=MXZzbHZ0b2VicDMxZw%3D%3D&utm_source=qr",
    facebook: "https://www.facebook.com/share/1EJ31Xxwww/",
    youtube: "https://youtube.com/@brooksgordonmusic?si=B0o2TJI0OR3p3KNs",
    spotify: "https://open.spotify.com/artist/6wvFCp98gDzaGroVfSEUhR?si=hCbKrdFUR6WPnXadlMDrjQ",
    appleMusic: "https://music.apple.com/us/artist/brooksgordon/1888380438"
  },
  logos: {
    main: "https://customer-assets.emergentagent.com/job_6201b490-8c1c-412b-abbe-451f841bd585/artifacts/pm2x5w6l_inbound934375847686363502.jpg",
    colored: "https://customer-assets.emergentagent.com/job_6201b490-8c1c-412b-abbe-451f841bd585/artifacts/pieyo1on_inbound8250031372632114154.jpg",
    waveform: "https://customer-assets.emergentagent.com/job_6201b490-8c1c-412b-abbe-451f841bd585/artifacts/okuqss3i_inbound6299682626283387206.jpg",
    header: "https://customer-assets.emergentagent.com/job_brooksgordon-music/artifacts/5wofsda7_inbound7162231249968684293.jpg"
  }
};

export const album = {
  title: "The Gordon Principle",
  artist: "Brooksgordon",
  releaseDate: "2026-03-13",
  coverArt: "https://customer-assets.emergentagent.com/job_f986b06d-88c3-46a1-b8a8-72940fbce0d8/artifacts/acvcm0bn_IMG_0138.png",
  description: "A lifetime of musical experience channeled into a highly anticipated collection of soulful melodies and heartfelt storytelling.",
  preOrderLinks: {
    spotify: "#",
    appleMusic: "#",
    amazon: "#",
    tidal: "#"
  }
};

export const featuredTracks = [
  {
    id: 1,
    title: "When I'm With You",
    artist: "Brooksgordon (formerly Brooks)",
    releaseYear: 2010,
    duration: "4:23",
    streamingLinks: {
      spotify: "https://open.spotify.com/track/7EVSxGNMrjUmWHJWM6PkuC?si=gvKkIaRZRSqYZ6mXNsfg0Q",
      appleMusic: "https://music.apple.com/us/album/when-im-with-you/411083135?i=411083139",
      youtube: "https://youtu.be/VjSc50fCsbY?si=eYSu4HbA2IsY2LPe"
    },
    coverArt: "https://customer-assets.emergentagent.com/job_brooksgordon-music/artifacts/0d9nrktd_IMG_1391%20Copy.jpeg"
  },
  {
    id: 2,
    title: "Real Love (Remix)",
    artist: "Brooksgordon",
    releaseYear: 2025,
    duration: "3:45",
    streamingLinks: {
      spotify: "https://open.spotify.com/track/2qfUT3JLw3460sLVnN0vZd?si=BUJThhAUTBmlim5QIlbJUw",
      appleMusic: "https://music.apple.com/us/song/real-love-remix/1888692892",
      youtube: "https://music.youtube.com/watch?v=9GS4pqUY7UM&si=LYg-75qLSqj7G5Nt"
    },
    coverArt: "https://customer-assets.emergentagent.com/job_f986b06d-88c3-46a1-b8a8-72940fbce0d8/artifacts/acvcm0bn_IMG_0138.png"
  }
];

export const videos = [
  {
    id: 1,
    title: "Whenever, Wherever, Whatever by Maxwell — Live at Atlanta Love & Poetry Event",
    platform: "direct",
    embedUrl: "https://customer-assets.emergentagent.com/job_gordon-music/artifacts/4shnymb2_87C55571-B4A9-425E-9C73-048EEBE71220%20Copy.mov",
    thumbnail: "https://images.unsplash.com/photo-1671492329310-4af9c7896776?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxsaXZlJTIwbXVzaWMlMjBwZXJmb3JtYW5jZSUyMHBpYW5vJTIwc291bCUyMHNpbmdlciUyMHN0YWdlfGVufDB8fHx8MTc3MzI0MTYzMHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Playing Keyboards for Grady Curve — Live at Atlanta Nightclub",
    platform: "direct",
    embedUrl: "https://customer-assets.emergentagent.com/job_gordon-music/artifacts/0ljo0px4_20191117_201129.mov",
    thumbnail: "https://images.unsplash.com/photo-1736012920787-dc078e56d980?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxsaXZlJTIwbXVzaWMlMjBwZXJmb3JtYW5jZSUyMHBpYW5vJTIwc291bCUyMHNpbmdlciUyMHN0YWdlfGVufDB8fHx8MTc3MzI0MTYzMHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "Beautiful - Official Video (Brooksgordon BKa Ishmael)",
    platform: "youtube",
    embedUrl: "https://www.youtube.com/embed/sV22s2pGCTg?si=7AiuYVLRC2oniqVM",
    thumbnail: "https://customer-assets.emergentagent.com/job_brooksgordon-music/artifacts/oozho8p1_IMG_0127.jpeg"
  },
  {
    id: 4,
    title: "Ribbon In the Sky by Stevie Wonder (practice cover)",
    platform: "youtube",
    embedUrl: "https://www.youtube.com/embed/iXUgDF3SIak",
    thumbnail: "https://img.youtube.com/vi/iXUgDF3SIak/maxresdefault.jpg"
  },
  {
    id: 5,
    title: "Live at The Pourhouse",
    platform: "instagram",
    embedUrl: "https://www.instagram.com/reel/DCF1n04vZB6/embed/",
    thumbnail: "https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=800&q=80"
  },
  {
    id: 6,
    title: "In Da Club by Dr. Dre & 50 (piano solo)",
    platform: "instagram",
    embedUrl: "https://www.instagram.com/p/CaBoznkjCjT/embed/",
    thumbnail: "https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=800&q=80"
  },
  {
    id: 7,
    title: "Breaking My Heart (Pretty Brown Eyes) by Mint Condition (practice piano & vocals done live)",
    platform: "instagram",
    embedUrl: "https://www.instagram.com/p/CZA2PZpLZ9i/embed/",
    thumbnail: "https://images.unsplash.com/photo-1520523839897-bd0b52f945a0?w=800&q=80"
  },
  {
    id: 8,
    title: "Angela bka 'Taxi Theme' by Bob James e-piano cover (excerpt)",
    platform: "instagram",
    embedUrl: "https://www.instagram.com/p/CYD65IXvsED/embed/",
    thumbnail: "https://images.unsplash.com/photo-1571974599782-87624638275e?w=800&q=80"
  },
  {
    id: 9,
    title: "All I've Ever Wanted by Mariah Carey & Walter Affanasieff (piano & vocal cover excerpt)",
    platform: "instagram",
    embedUrl: "https://www.instagram.com/p/CZA6U7fAUaf/embed/",
    thumbnail: "https://images.unsplash.com/photo-1552422535-c45813c61732?w=800&q=80"
  },
  {
    id: 10,
    title: "Ordinary Pain by Stevie Wonder (piano & vocal cover excerpt)",
    platform: "tiktok",
    embedUrl: "https://www.tiktok.com/t/ZP8H9pE8b/",
    thumbnail: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=800&q=80"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_d063d7a9-eda0-44cf-9fcf-715c92eeba27/artifacts/9ndt9ztt_1782956788931%281%29.png",
    alt: "Brooksgordon in a grey three-piece suit standing in a professional recording studio with a condenser mic and mixing console",
    caption: "Suited & Studio-Ready"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_d063d7a9-eda0-44cf-9fcf-715c92eeba27/artifacts/nufafxq7_image~6.jpg",
    alt: "Brooksgordon professional headshot, smiling",
    caption: "The Portrait"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_d063d7a9-eda0-44cf-9fcf-715c92eeba27/artifacts/h6jhe83k_image~7.jpg",
    alt: "Brooksgordon black & white headshot",
    caption: "Timeless"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_d063d7a9-eda0-44cf-9fcf-715c92eeba27/artifacts/2ddne1x9_image~8.jpg",
    alt: "Brooksgordon at his studio piano with his German Shepherd",
    caption: "Studio Companions"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_d063d7a9-eda0-44cf-9fcf-715c92eeba27/artifacts/wpnj3h13_image~3.jpg",
    alt: "Brooksgordon at the grand piano with vintage microphone in warm studio light",
    caption: "The Brooksgordon Grand"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_d063d7a9-eda0-44cf-9fcf-715c92eeba27/artifacts/zgyoarm5_image~4.jpg",
    alt: "Brooksgordon recording vocals in the studio with headphones",
    caption: "In the Booth"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_d063d7a9-eda0-44cf-9fcf-715c92eeba27/artifacts/wpnj3h13_image~3.jpg",
    alt: "Brooksgordon at a grand piano with a vintage microphone in a warm studio",
    caption: "Grand Piano Sessions"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_d063d7a9-eda0-44cf-9fcf-715c92eeba27/artifacts/7nvv5lz7_image~2.jpg",
    alt: "Brooksgordon performing live on piano with cheering crowd",
    caption: "Live On Stage"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_d063d7a9-eda0-44cf-9fcf-715c92eeba27/artifacts/4mikzjzb_image~5.jpg",
    alt: "Brooksgordon at the piano with vintage microphone, crowd lit by phone lights",
    caption: "Soul & Spotlights"
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_f986b06d-88c3-46a1-b8a8-72940fbce0d8/artifacts/pfttesl7_2011-11-03%2020.44.24_Original.jpeg",
    alt: "Brooksgordon in white suit",
    caption: "Classic Style"
  },
  {
    id: 11,
    url: "https://customer-assets.emergentagent.com/job_f986b06d-88c3-46a1-b8a8-72940fbce0d8/artifacts/2sathbme_IMG_20141016_194324_Original.jpeg",
    alt: "Brooksgordon portrait",
    caption: "Deep in Thought"
  },
  {
    id: 12,
    url: "https://customer-assets.emergentagent.com/job_f986b06d-88c3-46a1-b8a8-72940fbce0d8/artifacts/ud5mve0n_IMG_0752.jpeg",
    alt: "The Discussion - Life Talk",
    caption: "The Discussion"
  },
  {
    id: 13,
    url: "https://customer-assets.emergentagent.com/job_f986b06d-88c3-46a1-b8a8-72940fbce0d8/artifacts/2knup3bl_20170508_014750_Original.jpeg",
    alt: "Home studio setup",
    caption: "In the Studio"
  },
  {
    id: 14,
    url: "https://customer-assets.emergentagent.com/job_f986b06d-88c3-46a1-b8a8-72940fbce0d8/artifacts/oxsplffo_2013-11-19%2021.38.49_Original.jpeg",
    alt: "Brooksgordon casual portrait",
    caption: "Behind the Scenes"
  },
  {
    id: 15,
    url: "https://customer-assets.emergentagent.com/job_f986b06d-88c3-46a1-b8a8-72940fbce0d8/artifacts/mrk0zamq_IMG_0015.jpeg",
    alt: "Brooksgordon at work",
    caption: "The Day Job"
  },
  {
    id: 16,
    url: "https://customer-assets.emergentagent.com/job_f986b06d-88c3-46a1-b8a8-72940fbce0d8/artifacts/8t0z5i14_20160517_052426_Original.jpeg",
    alt: "DAW session",
    caption: "Making Beats"
  },
  {
    id: 17,
    url: "https://customer-assets.emergentagent.com/job_f986b06d-88c3-46a1-b8a8-72940fbce0d8/artifacts/mw5aw98v_20160307_011353_Original.jpeg",
    alt: "Late night studio session",
    caption: "Night Session"
  },
  {
    id: 18,
    url: "https://customer-assets.emergentagent.com/job_f986b06d-88c3-46a1-b8a8-72940fbce0d8/artifacts/hzes0vrv_20170508_014750_Original.jpeg",
    alt: "Home studio with keyboards",
    caption: "The Setup"
  },
  {
    id: 19,
    url: "https://customer-assets.emergentagent.com/job_f986b06d-88c3-46a1-b8a8-72940fbce0d8/artifacts/48tm7ycv_20160307_005942_Original.jpeg",
    alt: "Mic and headphones",
    caption: "Recording Ready"
  },
  {
    id: 20,
    url: "https://customer-assets.emergentagent.com/job_f986b06d-88c3-46a1-b8a8-72940fbce0d8/artifacts/d76nwlcj_2011-10-31%2021.04.04_Original.jpeg",
    alt: "Young Brooksgordon throwback",
    caption: "The Early Days"
  },
  {
    id: 21,
    url: "https://customer-assets.emergentagent.com/job_f986b06d-88c3-46a1-b8a8-72940fbce0d8/artifacts/9e0gn73y_20170508_014802_Original.jpeg",
    alt: "Roland XP keyboard studio setup",
    caption: "The Command Center"
  }
];
